import img1 from '../../../../resource/ImageBackGround/img1.jpg'
import img2 from '../../../../resource/ImageBackGround/img2.jpg'
import img3 from '../../../../resource/ImageBackGround/img3.jpg'
import img4 from '../../../../resource/ImageBackGround/img4.jpg'
import img5 from '../../../../resource/ImageBackGround/img5.jpg'
import img6 from '../../../../resource/ImageBackGround/img6.jpg'
import img7 from '../../../../resource/ImageBackGround/img7.jpg'
import img8 from '../../../../resource/ImageBackGround/img8.jpg'
import img9 from '../../../../resource/ImageBackGround/img9.jpg'
import img10 from '../../../../resource/ImageBackGround/img10.jpg'

export const LstImage = [
    { src: img1, name: 'img1' },
    { src: img2, name: 'img2' },
    { src: img3, name: 'img3' },
    { src: img4, name: 'img4' },
    { src: img5, name: 'img5' },
    { src: img6, name: 'img6' },
    { src: img7, name: 'img7' },
    { src: img8, name: 'img8' },
    { src: img9, name: 'img9' },
    { src: img10, name: 'img10' },
]
